<div *ngIf="this.lessonPlan != null">
  <div class="row">
    <div class="col table-title">{{ this.lessonPlan.title }} : by {{ this.lessonPlan.member.knownAs }}</div>
  </div>
  <div class="row">
    <div class="col-3 column-label">Description</div>
    <div class="col-9">
      {{ this.lessonPlan.description }}
    </div>
  </div>
  <div class="row">
    <div class="col-3 column-label">Due Date</div>
    <div class="col-9">
      {{ this.datePipe.transform(this.lessonPlan.dueDate, 'MM-dd-yyyy') }}
    </div>
  </div>
  <div class="row">
    <div class="col-3 column-label">Participants</div>
    <div class="col-9">
      {{ this.displayParticipants(this.lessonPlan.planMembers) }}
    </div>
  </div>
  <div class="row">
    <div class="col-3 column-label">Invitations</div>
    <div class="col-9">
      {{ this.displayInvitees(this.lessonPlan.planMembers) }}
    </div>
  </div>
  <div class="row">
    <div class="col-10 table-title">
      Steps
    </div>
    <div class="col-2 table-title">
      Notes
    </div>
  </div>
  <div class="row" *ngFor="let planItem of this.lessonPlan.planItems; let i = index;" [ngClass]="{'evenRow':i % 2 == 0, 'oddRow': i % 2 != 0}">
    <div *ngIf="planItem.type === 'LABEL'" class="col-10 column-label">
      {{ planItem.value }}
    </div>
    <div *ngIf="planItem.type === 'Pattern'" class="col-10">
      {{ planItem.patternSequence }}. {{ planItem.value }}
    </div>
    <div (click)="this.navigateToNotes(planItem.id)" class="col-2 clickable">
      <i class="fa fa-sticky-note-o" aria-hidden="true"></i>
      <span>
        {{ planItem.itemNotes.length }}
      </span>
    </div>
  </div>
</div>
